import AppConstants from '../config/app.constants';

let LedgerService = function ($http, $q) {

    let all = (search, offset, limit) => {
        return $http
            .get(AppConstants.api + `/ledger`, {
                params: {
                    search,
                    offset,
                    limit
                }
            })
            .then((res) => {
                return res.data
            })
    };
    
    let get = (id) => {
        return $http
            .get(AppConstants.api + `/ledger/${id}`)
            .then((res) => {
                return res.data
            })
    };

    return {
        all,
        get
    };

};

LedgerService.$inject = ['$http', '$q']

export default LedgerService;


// WEBPACK FOOTER //
// ./client/app/services/ledger.service.js